module.exports = __webpack_public_path__ + "media/images/icon_comment_yellow-396880cd3bdfb81004903f063ed0820c.png";